module.exports = __webpack_public_path__ + "static/img/33.838e0265.png";